// extracted by mini-css-extract-plugin
module.exports = {"statsChart":"styles_statsChart__25nlm","statsQty":"styles_statsQty__1eKIP","statsAverage":"styles_statsAverage__1vwPX","chart":"styles_chart__1S11E","tax":"styles_tax__3Zu93"};